import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('_atk');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        // 🧹 Clear token/localStorage
        localStorage.removeItem('_atk');
        localStorage.clear(); // Optional: clear all localStorage

        // 🔁 Redirect to login
        window.location.href = '/';

        return Promise.reject({ message: 'Unauthorized. Redirecting to login.' });
      }

      console.error('API Error:', status, error.response.data);
      return Promise.reject(error.response.data);
    } else {
      console.error('Network Error:', error.message);
      return Promise.reject({ message: 'Network error' });
    }
  }
);


const api = {
  get: (url, config = {}) => apiClient.get(url, config),
  post: (url, data, config = {}) => apiClient.post(url, data, config),
  put: (url, data, config = {}) => apiClient.put(url, data, config),
  delete: (url, config = {}) => apiClient.delete(url, config),
};

export default api;
